import { useState, useRef, useEffect } from 'react';

interface LogicToggleProps {
  value: 'and' | 'or';
  onChange: (value: 'and' | 'or') => void;
}

export function LogicToggle({ value, onChange }: LogicToggleProps) {
  const [isOpen, setIsOpen] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (containerRef.current && !containerRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <div ref={containerRef} className="relative inline-flex items-center mx-1">
      <button
        type="button"
        onClick={() => setIsOpen(!isOpen)}
        className="px-2 py-0.5 text-xs font-medium text-gray-600 bg-gray-100 hover:bg-gray-200 rounded transition-colors cursor-pointer"
      >
        {value === 'and' ? 'AND' : 'OR'}
      </button>

      {isOpen && (
        <div className="absolute top-full left-0 mt-1 bg-white rounded-lg shadow-lg border border-gray-200 py-1 z-50">
          <button
            type="button"
            onClick={() => {
              onChange('and');
              setIsOpen(false);
            }}
            className={`w-full px-3 py-1.5 text-xs text-left hover:bg-gray-50 flex items-center gap-2 cursor-pointer ${
              value === 'and' ? 'text-orange-600' : 'text-gray-700'
            }`}
          >
            AND
            {value === 'and' && <span className="text-orange-500">&#10003;</span>}
          </button>
          <button
            type="button"
            onClick={() => {
              onChange('or');
              setIsOpen(false);
            }}
            className={`w-full px-3 py-1.5 text-xs text-left hover:bg-gray-50 flex items-center gap-2 cursor-pointer ${
              value === 'or' ? 'text-orange-600' : 'text-gray-700'
            }`}
          >
            OR
            {value === 'or' && <span className="text-orange-500">&#10003;</span>}
          </button>
        </div>
      )}
    </div>
  );
}
